<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">代理商编号</label>
            <span class="weui-form-preview__value">{{item.agentcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">代理商名称</label>
            <span class="weui-form-preview__value">{{item.agentname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">访问人</label>
            <span class="weui-form-preview__value">{{item.creatorName}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">拜访日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.cv_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户</label>
            <span class="weui-form-preview__value">{{item.cv_custname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">被访人</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">
              {{item.cv_contect}} 
              <call-mobile :mobile="item.cv_tel"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">下次拜访日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.cv_nextdate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">需求产品</label>
            <span class="weui-form-preview__value">{{item.cv_needprod}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">应用场景</label>
            <span class="weui-form-preview__value">{{item.cv_useprod}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">需求量</label>
            <span class="weui-form-preview__value">{{item.cv_needqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">创建时间</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.createTime}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CallMobile from "@/components/button/CallMobile.vue";

export default {
  components: {
    CallMobile
  },
  data() {
    var item = this.$route.params.item
    return {
      item,
    }
  }
}
</script>